export default "__VITE_PUBLIC_ASSET__55dc966f__"